import Question from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/questionsTable/Question/Question";

export default Question;
